<template>
    <div class="mb-2">
        <NuxtLink
            v-if="orgRoute"
            class="text-primary-875 dark:text-primary-300 underline hover:no-underline"
            :event="preview ? '' : 'click'"
            :title="$t('jobView.showOrganization')"
            :to="orgRoute"
            @click="
                $exponea.track('zaujem_info_organizacia', {
                    orgId: org.id
                })
            "
        >
            {{ org.title }}
        </NuxtLink>
        <span v-else class="text-primary-875 dark:text-primary-300">
            {{ org.title }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Org } from '#shared/types/Org'

interface Props {
    org: Pick<Org, 'id' | 'slug' | 'title'>
    showImgOnDesktop?: boolean
    preview?: boolean
}

const props = defineProps<Props>()
const nuxtApp = useNuxtApp()
const { $exponea } = nuxtApp

const orgRoute = computed(() => {
    const id = props.org?.slug || props.org?.id
    if (!id) return null
    return {
        name: 'orgs-id',
        params: { id }
    }
})
</script>
